import React from 'react';
import { ModalContent, ModalFooter } from 'fronton-react';
import { css } from 'linaria';
import { ButtonWithGAClickButton, List, ListItem, ModalHeader, Typography } from 'common/components';
import { CONSTRUCTION_HOUSES_ELEMENT_BLOCK } from '../../../../construction-houses-constants';

const forProfiList = css`
  && {
    li:not(:last-child) {
      margin-bottom: 8px;

      @media (--only-mobile) {
        margin-bottom: 4px;
      }
    }

    margin-bottom: 24px;
  }
`;

export const ForProfi: React.FC = () => (
  <>
    <ModalHeader title="Бонусы для профессионалов" />
    <ModalContent>
      <List listStyle="disc" className={forProfiList}>
        <ListItem>
          <Typography variant="m" size="body_long" adaptive={false}>
            Возвращаем до&nbsp;20% баллами
          </Typography>
        </ListItem>
        <ListItem>
          <Typography variant="m" size="body_long" adaptive={false}>
            Дарим скидки на&nbsp;бренды за&nbsp;объём покупок
          </Typography>
        </ListItem>
        <ListItem>
          <Typography variant="m" size="body_long" adaptive={false}>
            Предоставляем расширенный ассортимент под&nbsp;заказ
          </Typography>
        </ListItem>
        <ListItem>
          <Typography variant="m" size="body_long" adaptive={false}>
            Возврат товара без чека в&nbsp;течение 2&nbsp;лет, при&nbsp;покупке по&nbsp;ключ-карте
          </Typography>
        </ListItem>
      </List>
      <Typography variant="m" size="body_long" adaptive={false}>
        Зарабатывайте вместе с&nbsp;нами&nbsp;&mdash; станьте партнёром Лемана ПРО!
      </Typography>
    </ModalContent>
    <ModalFooter>
      <ButtonWithGAClickButton
        elementBlock={CONSTRUCTION_HOUSES_ELEMENT_BLOCK}
        elementName="Подробности"
        elementText="Бонусы для профессионалов"
        href="/postavshchikam/uslugi/"
        wide
        variant="outline">
        Подробности
      </ButtonWithGAClickButton>
    </ModalFooter>
  </>
);
